export default "__VITE_ASSET__6a460c83__"